import { basePath } from 'src/env';

export const RoutePaths = {
    index: `${basePath}/`,
    tasks: `${basePath}/tasks/:taskId?`,
    process: `${basePath}/process/:processKey`,
    loanApplications: `${basePath}/loan-applications`,
    loanApplicationDetails: `${basePath}/loan-applications/:loanApplicationId`,
    loanApplicationCreate: `${basePath}/loan-applications/create`,
    loanApplicationProcess: (processName: string) =>
        `${basePath}/loan-applications/process/${processName}`,
    loans: `${basePath}/loans`,
    loanDetails: `${basePath}/loans/:loanId`,
    loanCreate: `${basePath}/loans/create`,
    products: `${basePath}/products`,
    productDetails: `${basePath}/products/:productId`,
    productCreate: `${basePath}/products/create`,
    campaigns: `${basePath}/campaigns`,
    campaignsDetails: `${basePath}/campaigns/:campaignId`,
    campaignsCreate: `${basePath}/campaigns/create`,
    transactions: `${basePath}/transactions`,
    transactionDetails: `${basePath}/transactions/:transactionId`,
    operations: `${basePath}/loans/:loanId/operations`,
    operationDetails: `${basePath}/loans/:loanId/operations/:operationId`,
    borrowers: `${basePath}/borrowers`,
    borrowerDetails: `${basePath}/borrowers/:productId`,
    collections: `${basePath}/collections`,
    collectionsDetail: `${basePath}/collections/:collectionId`,
    collaterals: `${basePath}/collaterals`,
    collateralDetails: `${basePath}/collaterals/:collateralId`,
    agents: `${basePath}/agents`,
    merchantDetails: `${basePath}/agents/:merchantId`,
    agentsCreate: `${basePath}/agents/create`,
    notAccessPage: `${basePath}/notAccessPage`,
    profile: (authServerUrl: string, authRealm: string) =>
        `${authServerUrl}/realms/${authRealm}/account`,
    formioSandBox: `${basePath}/formio-sandbox`,
    leads: `${basePath}/leads`,
    leadsDetails: `${basePath}/leads/:leadId`,
    leadsCreate: `${basePath}/leads/create`,
    viewProfile: `${basePath}/profile`,
    viewProfileDetails: `${basePath}/profile/:me`,
    agentLoanApplication: `${basePath}/agent-loan-applications`,
    agentLoanApplicationDetails: `${basePath}/agent-loan-applications/:agentLoanApplicationId`,
    agentLoanApplicationCreate: `${basePath}/agent-loan-applications/create`,
    agentLoanApplicationProcess: (processName: string) =>
        `${basePath}/agent-loan-applications/process/${processName}`,
    agentLoans: `${basePath}/agent-loans`,
    agentLoanDetails: `${basePath}/agent-loans/:loanId`,
    agentLoanCreate: `${basePath}/agent-loans/create`,
    operationsAgent: `${basePath}/agent-loans/:loanId/operations`,
    operationDetailsAgent: `${basePath}/agent-loans/:loanId/operations/:operationId`,
    analytics: `${basePath}/analytics`,
    analyticsDetails: `${basePath}/analytics/:dashboardId`,
    settings: `${basePath}/settings`,
    settingsInterestRate: `${basePath}/settings/interest-rate`,
    settingsApplicationLicense: `${basePath}/settings/application-license`,
    settingsLandingPage: `${basePath}/settings/landing-page`,
    settingsLandingPageEdit: `${basePath}/settings/landing-page/edit`,
    settingsNotificationTemplates: `${basePath}/settings/notification-templates`,
    settingsNotificationTemplateEdit: `${basePath}/settings/notification-templates/:id/edit`,
    settingsNotificationTemplateProcess: `${basePath}/settings/notification-templates/process/:processKey`,
    settingsScoringModel: `${basePath}/settings/scoring-model`,
    settingScoringModelDetails: `${basePath}/settings/scoring-model/:entityId`,
    settingScoringModelVersionDetails: `${basePath}/settings/scoring-model/:entityId/versions/:subEntityId`,
    settingsDocumentTemplates: `${basePath}/settings/document-templates`,
    settingsDocumentTemplatesProcess: `${basePath}/settings/document-templates/process/:processKey`,
};
